import { render } from "./form-organizations.vue?vue&type=template&id=2312e8ed&ts=true"
import script from "./form-organizations.vue?vue&type=script&lang=ts"
export * from "./form-organizations.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__